import '@/app/styles/fonts/Klein/stylesheet.css'
import '@/app/styles/tailwind.css'

import { queryClient } from '@/api/main/instance'
import App from '@/app/App.tsx'

import { ThemeProvider } from '@/app/providers/ThemeProvider'
import { ToastContextProvider } from '@/app/providers/ToastProvider'
import { store } from '@/store/store.ts'
import { QueryClientProvider } from '@tanstack/react-query'
// import { StrictMode } from 'react'
import * as Sentry from '@sentry/react'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import './app/plugins'

async function prepare() {
  if (import.meta.env.VITE_ENV === 'develop') {
    const { worker } = await import('./mocks/browser')
    await worker.start({
      onUnhandledRequest: 'bypass',
    })
  }
}

prepare().then(() => {
  const container = document.getElementById('root')!
  const root = createRoot(container, {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack)
    }),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  })

  root.render(
    <QueryClientProvider client={queryClient}>
      <ToastContextProvider>
        <ThemeProvider>
          <Provider store={store}>
            <App />
            <ReactQueryDevtools initialIsOpen={false} />
          </Provider>
        </ThemeProvider>
      </ToastContextProvider>
    </QueryClientProvider>
  )
})
